// extracted by mini-css-extract-plugin
export var quillEditor = "_my-1";
export var variable = "_my-0";